import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EComService } from '@src/app/ecom-services/ecom-common.service';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';


@NgModule({
  imports: [
    CommonModule,
    OAuthModule.forRoot()
  ],
  providers: [
    OAuthService,
    { provide: OAuthStorage, useValue: localStorage }
  ]
})
export class GoogleAuthModule {
  constructor(private oauthService: OAuthService, public ecomservice: EComService) {
    this.configureOAuth();
  }

  private configureOAuth() {

    const authConfig = {
      clientId: this.ecomservice.GetOlarConfigValue('GOOGLE_APP_ID'),
      redirectUri: `${window.location.origin}/${this.ecomservice.GetOlarConfigValue('PREFIX_ROUTING')}google/callback`,//window.location.origin,
      scope: 'openid profile email',
      issuer: 'https://accounts.google.com', // This is the issuer URL
      responseType: 'token id_token',
      showDebugInformation: true,
      tokenEndpoint: 'https://oauth2.googleapis.com/token',
      userinfoEndpoint: 'https://www.googleapis.com/oauth2/v3/userinfo',
      revocationEndpoint: 'https://oauth2.googleapis.com/revoke',
      strictDiscoveryDocumentValidation: false,
    };
    this.oauthService.configure(authConfig);
    // this.oauthService.loadDiscoveryDocumentAndTryLogin();
    this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
      console.log('Discovery document loaded and login attempted.');
    }).catch(err => {
      console.log(`Error loading discovery document: ${err}`);
    });
  }
}
